import axios from "axios"
import {API_URL_ROOT, API_URL_LOCAL} from "./config";

const headersWithAccessToken = (accessToken) => {
  return {
    Authorization: "Bearer " + accessToken,
    "Content-Type": "application/json;charset=utf-8",
    Accept: "application/json;charset=utf-8"
  }
}

export async function fetchGraphQL(accessToken, query, variables) {
  const res = await axios({
    method: "post",
    url: API_URL_LOCAL,
    headers: headersWithAccessToken(accessToken),
    data: {
      query,
      variables
    },
    withCredentials: true
  })
  return res.data
}

export async function graphql(query){
  return  fetch(`${API_URL_ROOT}/graphql`, query);
}

export async function post(url, payload) {

  return await fetch(`${API_URL_ROOT}/${url}`, {
    method: "POST",
    body: JSON.stringify(payload),
    json: true,
    headers: {
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
      "content-type": "application/json"
    }
  });
}

export async function get(url) {
  // console.log("=======",`${API_URL_ROOT}/${url}`);
  return await fetch(`${API_URL_ROOT}/${url}`, {
    json: true,
    headers: {
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
      "content-type": "application/json"
    }
  });
}

export async function patch(url, payload) {
  return await fetch(`${API_URL_ROOT}/${url}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
    json: true,
    headers: {
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
      "content-type": "application/json"
    }
  });
}

export async function put(url, payload) {
  return await fetch(`${API_URL_ROOT}/${url}`, {
    method: "PUT",
    body: JSON.stringify(payload),
    json: true,
    headers: {
      "cache-control": "no-cache",
      Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
      "content-type": "application/json"
    }
  });
}
export async function putImage(url, payload) {
  return await fetch(`${API_URL_ROOT}/${url}`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "content-type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("Authorization")}`,
      "cache-control": "no-cache",
      "Content-Length": JSON.stringify(payload).length,
      keepAlive: true
    }
  });
}
